// =============================================
// frontend/src/hooks/useAuth.js
// =============================================
// Ye custom hook backend se current user ka status check karta hai.
// App load hote hi /auth/me call karta hai.
// Return karta hai: { user, loading, error, refetch }
//
// Agar user authenticated hai → user object milega
// Agar nahi hai → user null hoga (401 response)

import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { buildApiUrl } from '../utils/api';

const useAuth = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchUser = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            // /auth/me se current user fetch karo
            // withCredentials: true zaroori hai taaki httpOnly cookie send ho
            const res = await axios.get(buildApiUrl('/auth/me'), { withCredentials: true });
            setUser(res.data);
        } catch (err) {
            if (err.response?.status === 401) {
                // 401 = not logged in — yeh error nahi, normal state hai
                setUser(null);
            } else {
                // Koi aur error (network, server down, etc.)
                setError(err.message);
                setUser(null);
            }
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchUser();
    }, [fetchUser]);

    return { user, loading, error, refetch: fetchUser };
};

export default useAuth;
